<template>
    <div id="header" :class="{header: isHeader}">
        <div ref="background" class="background"></div>
        <canvas ref="canvas"></canvas>
        <svg ref="svg" width="100%" height="100%" viewBox="0 0 552 45" version="1.1" xmlns="http://www.w3.org/2000/svg"  xml:space="preserve">
            <g id="name">
                <text x="0.499px" y="43.8px">Alex van Vliet</text>
                <g>
                    <path d="M29.344,43.8l8.797,0l-14.229,-43.2l-8.796,0l9.091,27.603l-9.641,-0.02l4.876,-14.448l-8.797,0l-10.146,30.065l8.797,0l2.459,-7.288l15.199,0.031l2.39,7.257l0,0Z"/>
                    <path d="M71.68,26.8l0,8.06l-20.048,0l0,-34.26l-8.797,0l0,43.2l37.642,0l0,-17l-8.797,0Z"/>
                    <path d="M85.171,0.6l0,8.599l37.642,0l0,-8.599l-37.642,0Zm8.797,25.858l19.835,0l0,-8.599l-28.632,0l0,25.941l37.642,0l0,-8.599l-28.845,0l0,-8.743Z"/>
                    <path d="M148.655,16.517l6.844,0l9.641,-15.917l-8.796,0l-8.664,14.303l-8.647,-14.303l-11.526,0l16.494,27.283l-6.852,0l-9.642,15.917l8.797,0l8.668,-14.31l8.651,14.31l11.526,0l-16.494,-27.283l0,0Z"/>
                    <path d="M231.317,0.6l-8.797,0l-10.159,30.025l-9.889,-30.025l-8.797,0l14.228,43.2l8.797,-0.001l14.617,-43.199l0,0Z"/>
                    <path d="M264.856,43.8l8.797,0l-14.229,-43.2l-8.796,0l9.091,27.603l-9.641,-0.02l4.876,-14.448l-8.797,0l-10.146,30.065l8.797,0l2.459,-7.288l15.199,0.031l2.39,7.257l0,0Z"/>
                    <path d="M307.192,0.635l0,29.991l-20.048,-30.026l-8.797,0.035l0,43.165l8.797,0l0,-30.026l20.048,30.026l8.797,0l0,-43.165l-8.797,0Z"/>
                    <path d="M382.157,0.6l-8.797,0l-10.159,30.025l-9.889,-30.025l-8.797,0l14.228,43.2l8.797,-0.001l14.617,-43.199l0,0Z"/>
                    <path d="M415.696,26.8l0,8.06l-20.048,0l0,-34.26l-8.797,0l0,43.2l37.642,0l0,-17l-8.797,0Z"/>
                    <path d="M466.828,9.317l0,-8.715l-37.641,0l0,8.715l14.527,0l0,25.768l-14.526,0l0,8.715l37.64,0l0,-8.715l-14.526,0l0,-25.768l14.526,0Z"/>
                    <path d="M471.523,0.6l0,8.599l37.642,0l0,-8.599l-37.642,0Zm8.797,25.858l19.835,0l0,-8.599l-28.632,0l0,25.941l37.642,0l0,-8.599l-28.845,0l0,-8.743Z"/>
                    <path d="M513.859,0.602l0,8.604l14.423,0l0,34.594l8.796,0l0,-34.594l14.423,0l0,-8.604l-37.642,0l0,0Z"/>
                </g>
            </g>
        </svg>
        <div ref="balls" class="loader">
            <div ref="ball1" class="ball ball-1" style="left: 0%; transform: translateX(0);"></div>
            <div ref="ball2" class="ball ball-2" style="left: 50%; transform: translateX(0);"></div>
        </div>
		<svg ref="glitch" id="glitch" width="100%" height="100%" viewBox="0 0 552 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve">
            <defs>
                <filter id="glitch-filter">
                    <feFlood flood-color="black" result="black"></feFlood>
                    <feFlood flood-color="red" result="flood1"></feFlood>
                    <feFlood flood-color="limegreen" result="flood2"></feFlood>
                    <feOffset in="SourceGraphic" dx="3" dy="0" result="off1a"></feOffset>
                    <feOffset in="SourceGraphic" dx="2" dy="0" result="off1b"></feOffset>
                    <feOffset in="SourceGraphic" dx="-3" dy="0" result="off2a"></feOffset>
                    <feOffset in="SourceGraphic" dx="-2" dy="0" result="off2b"></feOffset>
                    <feComposite in="flood1" in2="off1a" operator="in" result="comp1"></feComposite>
                    <feComposite in="flood2" in2="off2a" operator="in" result="comp2"></feComposite>
                    <feMerge x="0" width="100%" result="merge1" y="104px" height="1.43076px">
                        <feMergeNode in="comp1"></feMergeNode>
                        <feMergeNode in="off1b"></feMergeNode>
                        <animate attributeName="y" id="y" dur="4s" values="104px; 104px; 30px; 105px; 30px; 2px; 2px; 50px; 40px; 105px; 105px; 20px; 6ßpx; 40px; 104px; 40px; 70px; 10px; 30px; 104px; 102px" keyTimes="0; 0.362; 0.368; 0.421; 0.440; 0.477; 0.518; 0.564; 0.593; 0.613; 0.644; 0.693; 0.721; 0.736; 0.772; 0.818; 0.844; 0.894; 0.925; 0.939; 1" repeatCount="indefinite"></animate>
                        <animate attributeName="height" id="h" dur="4s" values="10px; 0px; 10px; 30px; 50px; 0px; 10px; 0px; 0px; 0px; 10px; 50px; 40px; 0px; 0px; 0px; 40px; 30px; 10px; 0px; 50px" keyTimes="0; 0.362; 0.368; 0.421; 0.440; 0.477; 0.518; 0.564; 0.593; 0.613; 0.644; 0.693; 0.721; 0.736; 0.772; 0.818; 0.844; 0.894; 0.925; 0.939; 1" repeatCount="indefinite"></animate>
                    </feMerge>
                    <feMerge x="0" width="100%" y="98.9108px" height="3.63849px" result="merge2">
                        <feMergeNode in="comp2"></feMergeNode>
                        <feMergeNode in="off2b"></feMergeNode>
                        <animate attributeName="y" id="y" dur="4s" values="103px; 104px; 69px; 53px; 42px; 104px; 78px; 89px; 96px; 100px; 67px; 50px; 96px; 66px; 88px; 42px; 13px; 100px; 100px; 104px;" keyTimes="0; 0.055; 0.100; 0.125; 0.159; 0.182; 0.202; 0.236; 0.268; 0.326; 0.357; 0.400; 0.408; 0.461; 0.493; 0.513; 0.548; 0.577; 0.613; 1" repeatCount="indefinite"></animate>
                        <animate attributeName="height" id="h" dur="4s" values="0px; 0px; 0px; 16px; 16px; 12px; 12px; 0px; 0px; 5px; 10px; 22px; 33px; 11px; 0px; 0px; 10px" keyTimes="0; 0.055; 0.100; 0.125; 0.159; 0.182; 0.202; 0.236; 0.268; 0.326; 0.357; 0.400; 0.408; 0.461; 0.493; 0.513;  1" repeatCount="indefinite"></animate></feMerge>
                    <feMerge><feMergeNode in="SourceGraphic"></feMergeNode>
                        <feMergeNode in="merge1"></feMergeNode>
                        <feMergeNode in="merge2"></feMergeNode>
                    </feMerge>
                </filter>
            </defs>
            <text x="193.675px" y="44.8px">
				Soon
			</text>
		</svg>
    </div>
</template>

<script type="text/javascript">
    import Granim from 'granim'
    import Vivus from 'vivus'
    import Velocity from 'velocity-animate'
    const slows = [0, 0.8, 1, 1]// Départ rapide et ralenti
    const accelerates = [0.8, 0, 1, 1]// Accélère et stop net

    export default {
        name: 'header',
        data () {
            return {
                granimInstance: null,
                vivusInstance: null,
                isLoading: true,
                isHeader: false
            }
        },
        methods: {
            ball1ToRight () {
                let $this = this
                Velocity($this.$refs.ball1, {
                    left: '50%',
                    translateX: '-20px'
                }, {
                    easing: accelerates,
                    duration: 1000,
                    complete () {
                        if ($this.isLoading) {
                            $this.ball2ToRight()
                        } else {
                            $this.header()
                        }
                    }
                })
            },
            ball2ToRight () {
                let $this = this
                Velocity($this.$refs.ball2, {
                    left: '100%',
                    translateX: '-20px'
                }, {
                    easing: slows,
                    duration: 1000,
                    complete () {
                        $this.ball2ToLeft()
                    }
                })
            },
            ball2ToLeft () {
                let $this = this
                Velocity($this.$refs.ball2, {
                    left: '50%',
                    translateX: '0px'
                }, {
                    easing: accelerates,
                    duration: 1000,
                    complete () {
                        if ($this.isLoading) {
                            $this.ball1ToLeft()
                        } else {
                            $this.header()
                        }
                    }
                })
            },
            ball1ToLeft () {
                let $this = this
                Velocity($this.$refs.ball1, {
                    left: '0%',
                    translateX: '0px'
                }, {
                    easing: slows,
                    duration: 1000,
                    complete () {
                        $this.ball1ToRight()
                    }
                })
            }
        },
        mounted () {
            this.granimInstance = new Granim({
                element: this.$refs.canvas,
                name: 'basic-gradient',
                direction: 'top-bottom',
                opacity: [1, 1],
                isPausedWhenNotInView: true,
                states: {
                    'default-state': {
                        gradients: [
                            ['#F0F2F0', '#000C40'],
                            ['#000C40', '#F0F2F0']
                        ]
                    }
                }
            })

            this.vivusInstance = new Vivus(this.$refs.svg, {
                duration: 200
            }, () => {
            })

            setTimeout(() => {
                this.ball1ToRight()
            }, 0)
        }
    }
</script>



// WEBPACK FOOTER //
// Header.vue?1e7a9776